import { object, array, number, string } from '@gogame/schemas';
import { defaultRangePreset, rangePresets } from '@gogame/intl-ts';

import {
  FILTER_CREATED,
  FILTER_APPLICATIONS,
  FILTER_DOMAINS,
  FILTER_LOCALES,
  FILTER_FLOWS,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_TAGS,
  FILTER_USED_IN_ADS,
  FILTER_IS_NEW,
} from 'scenes/Gallery/ConversionPages/constants';

export const filtersSchema = object({
  [FILTER_CREATED]: array(string())
    .default(rangePresets.LAST_12_MONTHS_PLUS_TODAY.value)
    .constants(defaultRangePreset),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_NETWORKS]: array(number()),
  [FILTER_PLATFORMS]: array(number()),
  [FILTER_DOMAINS]: array(string()),
  [FILTER_LOCALES]: array(string()),
  [FILTER_FLOWS]: array(number()),
  [FILTER_TAGS]: array(number()),
  [FILTER_USED_IN_ADS]: number(),
  [FILTER_IS_NEW]: number(),
}).stripEmpty();

export const EMPTY_FILTERS = {
  ...filtersSchema.default(),
};
